import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconGatsby = ({
  title = "Gatsby",
  viewBoxWidth = 56,
  viewBoxHeight = 56,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M28 0C12.6 0 0 12.6 0 28s12.6 28 28 28 28-12.6 28-28S43.4 0 28 0zM12.4 43.6C8.2 39.4 6 33.8 6 28.4L27.8 50c-5.6-.2-11.2-2.2-15.4-6.4zm20.4 5.8L6.6 23.2C8.8 13.4 17.6 6 28 6c7.4 0 13.8 3.6 17.8 9l-3 2.6C39.4 13 34 10 28 10c-7.8 0-14.4 5-17 12l23 23c5.8-2 10.2-7 11.6-13H36v-4h14c0 10.4-7.4 19.2-17.2 21.4z"
      fill="#639"
      fillRule="nonzero"
    />
  </Svg.Icon>
)

export default IconGatsby
